import { cilX } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { CButton, CCol, CRow, CTooltip } from "@coreui/react";

export default function SafetyMessage({ messages, hasDeleteButton = false, deleteMessage }) {
    return (<>
        {messages.length === 0 ? "No messages to show" : messages.map((m, i) => {
            let date = new Date(m.createdAt)

            return <CRow key={i}>
                <CCol sm={8} md={8} key={`${i}-info-col`} className='mb-2'>
                    <div key={`${i}-info-date`}>
                        {date.toLocaleDateString('en-ca', { month: 'long', day: 'numeric', year: 'numeric' })}
                    </div>
                    <div key={`${i}-info-time`} style={{ fontSize: '0.8rem' }}>
                        <i key={`${i}-italics`}>{date.toLocaleTimeString('en-ca', { hour: 'numeric', minute: 'numeric' })}</i>
                    </div>
                </CCol>
                {hasDeleteButton ? <CCol sm={4} md={4}>
                    <div style={{ display: "flex", justifyContent: "end" }}>
                        <CTooltip content='Delete'>
                            <CButton color='danger' onClick={() => { deleteMessage(m.safetyMessageId) }} className='m-1'>
                                <CIcon icon={cilX} />
                            </CButton>
                        </CTooltip>
                    </div>
                </CCol> : null}
                <CCol key={`${i}-details-col`} sm={12} md={12}>
                    {m.content}
                </CCol>
                <hr key={`${i}-hr`} className='my-2' />
            </CRow>
        })}
    </>)
}